import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { SessionService } from '@/core/session.service';

/**
 * Mapeo de URLs a IDs de permisos basado en menuItems
 */
const URL_TO_PERMISSION_MAP: Record<string, string> = {
  '/payments': 'MPRM01',
  '/simulations': 'MPRM02',
  '/credits': 'MPRM03',
  '/beneficiaries': 'MPRM07',
  '/inversors': 'MPRM08',
  '/settings': 'MPRM09',
  '/security': 'MPRM09', // Security es parte de settings
  '/profile': 'MPRM09', // Profile es parte de settings
  '/profile-type': 'MPRM09' // Profile type es parte de settings
};

/**
 * Guard funcional que valida si el usuario tiene el permiso necesario para acceder a una ruta.
 * El permiso se puede obtener de:
 * 1. route.data['permission'] - si se especifica en la configuración de la ruta
 * 2. URL_TO_PERMISSION_MAP - mapeo automático basado en la URL
 * 
 * Si el usuario no tiene el permiso, redirige a la página de error 403.
 */
export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  // Obtener el ID del permiso desde route.data o del mapeo de URLs
  const permissionId =
    route.data['permission'] ||
    URL_TO_PERMISSION_MAP[route.url.join('/')] ||
    URL_TO_PERMISSION_MAP['/' + route.url.join('/')];

  // Si no se encuentra un permiso configurado, permitir el acceso (fallback)
  if (!permissionId) {
    console.warn(
      `No se encontró permiso configurado para la ruta: ${route.url.join('/')}`
    );
    return true;
  }

  // Validar si el usuario tiene el permiso
  const hasPermission = sessionService.isGranted(permissionId);

  if (!hasPermission) {
    // Redirigir a error 403 si no tiene permiso
    router.navigateByUrl('/error/403', { skipLocationChange: true });
    return false;
  }

  return true;
};
